<template>
  <div>
    <div class="grid grid-cols-2 gap-5">
      <div class="col-span-2 w-full">
        <shipblu-input v-validate="{ required: true, max: 20, regex: /^[ \u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z0-9._-]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z0-9._-]*$/ }" name="store or brand name" :labelPlaceholder="$t('Store or Brand Name')" :required="true" autocomplete="nofill" v-model="merchantSignUp.name" type="text"/>
        <p class="md:text-[12px] text-[10px] text-black mt-2">{{$t('Store or Brand Name will be displayed on the shipping label')}}</p>
        <p class="text-danger text-sm" v-show="errors.has('store or brand name')">{{ errors.first('store or brand name') }}</p>
      </div>
      <div class="col-span-2 w-full">
        <shipblu-input v-validate="'url:require_protocol'" name="store url" :labelPlaceholder="$t('Website or Social Media Link')" autocomplete="nofill" v-model="merchantSignUp.store_url" type="text"/>
        <p class="text-danger text-[12px]" v-show="errors.has('store url')">{{ $t('Website or Social Media Link is incorrect') }}</p>
      </div>
      <div class="flex gap-3 col-span-2 w-full">
        <div class="w-2/3">
          <shipblu-input v-validate="'required'" name="street and building" :labelPlaceholder="$t('Street and Building')" :required="true" autocomplete="nofill" v-model="merchantSignUp.address.line_1" type="text"/>
          <p class="text-danger text-sm" v-show="errors.has('street and building')">{{ $t('Street and Building are required') }}</p>
        </div>
        <div class="w-1/3">
          <shipblu-input v-validate="'required'" name="flat no" :labelPlaceholder="$t('Flat No.')" :required="true" autocomplete="nofill" v-model="merchantSignUp.address.line_2" type="text"/>
          <p class="text-danger text-sm" v-show="errors.has('flat no')">{{ $t('Flat No. is required') }}</p>
        </div>
      </div>
      <div class="col-span-2 w-full">
        <shipblu-select v-validate="merchantSignUp.address.zone !== null ? '' : 'required'" :localize="true" :options="zones" optionLabel="name" inputId="input-zone" :required="true" :labelPlaceholder="$t('Zone')" name="zone" type="high_level" :inputValue="merchantSignUp.address.zone" @selectedOptions="selectZoneOptions($event)"/>
        <p class="text-danger text-sm" v-show="errors.has('zone')">{{ $t('Zone field is required') }}</p>
      </div>
      <div class="col-span-2 w-full">
        <shipblu-input v-validate="'required|numeric'" name="monthly volume" :labelPlaceholder="$t('Monthly Volume')" :required="true" autocomplete="nofill" v-model="merchantSignUp.committed_volume" type="text"/>
        <p class="text-danger text-sm" v-show="errors.has('monthly volume')">{{ $t('Monthly Shipping Volume is required') }}</p>
      </div>
      <div class="col-span-2 w-full">
        <shipblu-select :options="industries" :localize="true" v-validate="merchantSignUp.industry.value !== '' ? '' : 'required'" optionLabel="text" inputId="industry-input" :required="true" :labelPlaceholder="$t('Business Industry')" :inputValue="merchantSignUp.industry" @selectedOptions="selectIndustry($event)" name="industry"/>
        <p class="text-danger text-sm" v-show="errors.has('industry')">{{ $t('Business Industry is required') }}</p>
      </div>
    </div>
    <div class="mt-6 w-full">
      <button id="next-btn" @click="nextStep" class="w-full btn p-4">{{ $t('Next') }}</button>
    </div>
    <div class="mt-3">
      <span class="text-sm flex justify-end">
        <a :href="releaseVersion === 'staging' ? 'https://app.staging.shipblu.com/' : 'https://app.shipblu.com'">{{$t('Have an account? Sign in')}}</a>
      </span>
    </div>
  </div>
</template>

<script>
import staticZones from '../../../assets/utils/geo.json'
import ShipbluSelect from '../../../layouts/components/ShipbluSelect.vue'

export default {
  props: ['step', 'industries'],
  data () {
    return {
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION,
      zones: staticZones,
      merchantSignUp: {
        industry: { text: '', value: '' },
        address: {
          line_3: '',
          line_1: '',
          line_2: '',
          zone: null
        }
      }
    }
  },
  watch: {
  },
  components: {
    ShipbluSelect
  },
  methods: {
    updateMonthlyVolumeTrackingValue () {
      if (typeof window !== 'undefined') {
        window.monthlyVolume = this.merchantSignUp.committed_volume
      }
    },
    nextStep () {
      this.$validator.validateAll().then((result) => {
        if (result && this.merchantSignUp.address && this.merchantSignUp.address.zone && this.merchantSignUp.address.zone.id !== null && this.merchantSignUp.address.zone.id !== 284) {
          this.updateMonthlyVolumeTrackingValue()
          const merchantObj = {
            display_name: this.merchantSignUp.name,
            name:this.merchantSignUp.name,
            address: {
              line_1: this.merchantSignUp.address.line_1,
              line_2: this.merchantSignUp.address.line_2,
              zone: this.merchantSignUp.address.zone
            },
            committed_volume: this.merchantSignUp.committed_volume,
            store_url: this.merchantSignUp.store_url ? !this.merchantSignUp.store_url.startsWith('http://') && !this.merchantSignUp.store_url.startsWith('https://') ? `http://${this.merchantSignUp.store_url}` : this.merchantSignUp.store_url : '',
            industry: this.merchantSignUp.industry
          }
          localStorage.setItem('merchantSignUp', JSON.stringify(merchantObj))
          this.$emit('step', 2)
        }
      })
    },
    selectZoneOptions (value) {
      const zone = value[0]
      this.merchantSignUp.address.zone = zone
    },
    selectIndustry (value) {
      const industry = value[0]
      this.merchantSignUp.industry = industry
    }
  },
  created () {
    if (this.step === 1) {
      localStorage.getItem('merchantSignUp')
      if (localStorage.getItem('merchantSignUp')) {
        this.merchantSignUp = JSON.parse(localStorage.getItem('merchantSignUp'))
        this.updateMonthlyVolumeTrackingValue()
      }
    }
  }
}

</script>